import SignInMart from "./signInMart.js";
import { SignIn } from "@freshservice/bridge";
import { IS_PRO } from "@fresh/env";

import Device from "@sh/device-detector";
const device = new Device();
/* eslint-disable */
export default () => {
    if (device.in('ShiHangApp')) {
        SignIn.init({ from: 'app', test: !IS_PRO }).execute({RegisterType: 3078});
    } else {
        SignInMart.init({
            from: "wechat",
            test: !IS_PRO,
            baseUrl: IS_PRO
                ? "https://wechatx.34580.com/mart/#/"
                : "http://10.1.62.170:29503/mart/#",
            queryArray: [
                "isActivity=1",
                "RegisterMethod=" +
                    (device.in('Wechat')
                        ? 1500
                        : device.in('WeMini')
                            ? 1510
                            : device.in('IPAD')
                                ? 1400
                        : device.in('IOS')
                        ? 1200
                                    : device.in('Android')
                                        ? 1300
                        : 1600),
                `RegisterType=${3078}`
            ]
        }).execute()
    }
};
